<template>
  <div class="park-detail-info-ad" v-if="popularPushDatas.length">
    <!--     <div class="park-detail-info-sub-title">园区地块</div>-->
    <div id="dom" class="park-detail-info-sub scrollbar-definition">
      <div
        @click="parkDetailInfo(item)"
        v-for="(item, index) in popularPushDatas"
        :key="index"
        class="park-detail-info-ad-item"
      >
        <img
          :src="
            item.imgUrl ? item.imgUrl : require('@/assets/images/home/land.png')
          "
          class="ad-img-t"
        />
        <div class="park-detail-info-ad-item-r">
          <div class="ad-name">{{ item.name }}</div>
          <div class="ad-price">{{ item.typeName }}</div>
          <div class="ad-span">
            <div>{{ item.countyName }}</div>
            <div>{{ item.area }}亩</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="develop-style"
      @click="develop"
      v-if="popularPushDatas.length > 8"
    >
      <i :class="iconEdit"></i>
      <span>{{ developData }}</span>
    </div>
  </div>
  <div class="unavailable" v-else>
    <img src="@/assets/images/unavailable.png" alt="" />
  </div>
</template>

<script>
import { getParkPage, getParkLandList } from "@/api/setting/investment";
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/18 15:29
 * @Description 园区关联地块列表
 */
export default {
  name: "ParkPopularPush",
  // inject: ["reload"],
  props: {
    parkCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      popularPushDatas: [],
      developData: "展开更多",
      iconEdit: "el-icon-arrow-down",
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
    };
  },
  watch: {
    parkCode: function (newVal) {
      this.getList();
    },
  },
  mounted() {
    if (this.parkCode) {
      this.getList();
    }
  },
  methods: {
    parkDetailInfo(item) {
      this.$router.push({
        path: "/land/detail",
        query: { id: item.id },
      });
    },
    develop() {
      let dom = document.querySelector("#dom");
      if (this.developData === "展开更多") {
        this.developData = "收起";
        this.iconEdit = "el-icon-arrow-up";
        dom.style.height = "100%";
      } else {
        this.developData = "展开更多";
        this.iconEdit = "el-icon-arrow-down";
        dom.style.height = "440px";
      }
    },
    getList() {
      getParkLandList(this.parkCode).then((res) => {
        if (res.data.success) {
          this.popularPushDatas = res.data.data.length ? res.data.data : [];
          this.popularPushDatas.forEach((item) => {
            this.$set(
              item,
              "imgUrl",
              item.pronounceImages && item.pronounceImages.length
                ? this.imgUrl + item.pronounceImages[0].filePath
                : ""
            );
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.park-detail-info-ad {
  /*height: 230px;*/
  width: 100%;
}

.park-detail-info-sub-title {
  width: 200px;
  color: #495eb8;
  font-weight: 600;
  font-size: 1.12rem;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  padding: 12px 10px;
}
.park-detail-info-sub {
  display: flex;
  width: 100%;
  /*height: 100%;*/
  /*overflow: auto;*/
  flex-grow: 1;
  flex-wrap: wrap;
  height: 440px;
  overflow: hidden;
  cursor: pointer;
}
.park-detail-info-ad-item:nth-child(4n + 1) {
  margin-left: 0;
}
.park-detail-info-ad-item {
  border: 1px solid #d9d9d9;
  padding: 4px;
  box-sizing: border-box;
  /*margin: 8px 10px 8px 0;*/
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  /*width: 23%;*/
  flex: 0 0 auto;
  width: calc(100% / 4 - 8px);
  margin-top: 10px;
  height: 210px;
}

.ad-img-t {
  width: 100%;
  height: 125px;
}
.park-detail-info-ad-item-r {
  width: 100%;
  height: calc(100% - 125px);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.ad-name {
  font-size: 0.8rem;
  color: #303030;
}

.ad-price {
  color: #1446a6;
  font-size: 0.85rem;
  font-weight: bold;
}

.ad-info-box {
  display: flex;
  font-size: 0.75rem;
  color: #5c5c5c;
}
.ad-span {
  display: flex;
  font-size: 0.75rem;
  color: #828181;
}
.ad-span > div:first-child {
  padding-right: 10px;
  border-right: 1px solid #a9a8a8;
}
.ad-span > div:last-child {
  padding-left: 10px;
}
.develop-style {
  font-size: 0.85rem;
  cursor: pointer;
  color: #1446a6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eaeefb;
  padding: 10px;
  margin-top: 10px;
}
.unavailable {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
</style>
